import React, { PureComponent } from 'react';
import Button from '@dbk/ui-buttons';
import { createContainer } from '@dbk-legacy/muster/react'
import Text from '@dbk/ui-text'
import Modal from '@dbk/ui-modal';
import { NotificationConfirmation, StatusError } from '@dbk/ui-icons'
import { ROUTES } from '../../../constants';
class PaymentInitiationService extends PureComponent {

    onDone = async () => {
        const { changePage, pis: { resetPaymentStatus } } = this.props;
        await resetPaymentStatus();
        changePage(ROUTES.SUMMARY.DASHBOARD, true);
    }

    // Payment confirmation flow
    onExecute() {
        const { savePaymentExecution } = this.props;
        savePaymentExecution("confirm");
    }

    // Payment Rejection flow
    onCancel() {
        const { savePaymentExecution } = this.props;
        savePaymentExecution("reject");
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.pis.isPaymentOtpVerified != null) {
            this.props.pis.signConsent();
        }
    }
    render() {

        const {
            i18n: { messages },
        } = this.props;

        const isInternalPayment = true;
        return (
            <div className='profile-container'>
                <div className="profile-container__title" tabIndex={0}>
                    {!isInternalPayment && <h2>{messages['app.psd2.payment.sepa.pageTitle']}</h2>}
                    {isInternalPayment && <h2>{messages['app.psd2.payment.intl.pageTitle']}</h2>}
                </div>
                <div tabIndex={0}>
                    <Text size="big">{messages['app.psd2.payment.execute']} </Text>
                    <Text size="big">Klarna SOFORT </Text>
                </div>

                <div className="pt-10">
                    <div className="permission-summary">
                        <div className="row large-12" style={{ margin: '20px 0px 20px 0px' }}>
                            <div className="column large-6" tabIndex={0}>
                                <div>
                                    <Text size={"large"} secondary>{messages['app.payments.destination.to']} </Text>
                                </div>
                                <div>
                                    <div>John smith</div>
                                    <div>
                                        <Text secondary>{messages['app.dashboard.summaryData.accountName.label']}: </Text>
                                        <span>DE02100100109307118603</span>
                                    </div>
                                    <div>PostFinance AG (090000)</div>
                                    <div>Berne 3030 </div>
                                </div>
                            </div>
                            <div className="column large-6" tabIndex={0}>
                                <div className="column">
                                    <Text size={"large"} secondary>{messages['app.payments.destination.from']}</Text>
                                </div>
                                <div className="column large-3">
                                    <div>Current Account EUR </div>
                                    <div>EUR 1,099,511.08 </div>
                                    <div>DE02100100109307118603</div>
                                    <div>Portfolio 3067790.1001</div>
                                </div>
                                <div className="column large-3">
                                    <div>&nbsp;</div>
                                    <div>1234567800</div>
                                    <div><Text secondary>(as of Jun 18 2022)</Text></div>
                                </div>
                            </div>


                        </div>
                        <div className="large-6" style={{ padding: '10px' }} tabIndex={0}>
                            <div style={{ margin: '20px 0px 20px 0px' }}>
                                <Text secondary style={{ fontSize: 16 }}>Payment Details</Text>
                            </div>
                            <div>
                                <Text secondary style={{ fontWeight: "bold", fontSize: 16 }}>
                                    {messages['app.payments.summary.amount']} </Text>
                                <Text style={{ fontWeight: "bold", fontSize: 16 }}>EUR 100.00</Text>
                            </div>
                            <div>
                                <Text secondary>{messages['app.payments.summary.execDate']} </Text>
                                <Text>20 Jun 2022</Text>
                            </div>
                            <div >
                                <Text secondary>{messages['app.payments.summary.valueDate']} </Text>
                                <Text>20 Jun 2022</Text>
                            </div>
                            <div >
                                <Text secondary>{messages['app.payments.summary.paymentStatus']} </Text>
                                <Text>Non submitted</Text>
                            </div>
                            <div >
                                <Text secondary>{messages['app.payments.summary.referenceNumber']} </Text>
                                <Text>23423423432</Text>
                            </div>
                            <div>
                                <Text secondary>{messages['app.payments.remarks']} </Text>
                                <Text>Third party order no sdsd123-5345-5fsdf-34534vsdfdsf</Text>
                            </div>
                        </div>
                        {isInternalPayment && <div className="large-6" style={{ margin: '0px 0px 10px 10px' }}>
                            <div tabIndex={0}>
                                <Text secondary>{messages['app.psd2.payment.excute.fee']} </Text>
                                <Text>0.00 EUR</Text>
                            </div>
                            <div tabIndex={0}>
                                <Text secondary>
                                    {messages['app.psd2.payment.excute.xchngeLabel']}
                                </Text>
                            </div>
                        </div>}

                    </div>
                    <span>&nbsp;</span>
                    <span>&nbsp;</span>
                    <div >
                        <div className="row btn-container pt-10">
                            <div className="pr-10">
                                <Button size='large' tertiary={true} onPress={() => this.onCancel()}>
                                    {messages['app.payments.summary.reject']}
                                </Button>
                            </div>
                            <div className="pl-10">
                                <Button size='large' onPress={() => this.onExecute()}>{messages['app.payments.summary.confirm']}</Button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Payment - Success/Reject confirmation modal */}
                {this.props.pis.isPaymentOtpVerified != null &&
                    <Modal
                        isActive={true}
                        hideCloseButton={true}
                        header={<Text>{messages['app.psd2.payment.SuccessTitle']}</Text>}
                        className={"model-window-login"}
                        content={
                            <div className="modalHeight">
                                <div className="modalNotification" tabIndex={0}>
                                    {this.props.pis.isPaymentExecute ? <NotificationConfirmation width={30} color='#999' height={30} /> : <StatusError width={30} color='#999' height={30} />}
                                    <Text size={"large"} className="sucessLabel">
                                        {this.props.pis.isPaymentExecute ? messages['app.payments.confirmation.success'] : messages['app.payment.psd2.consent.reject']}
                                    </Text>
                                </div>
                                <div className="modalMsg" tabIndex={0}>
                                    <Text className="margin20">
                                        {this.props.pis.isPaymentExecute ? messages['app.psd2.payment.successMsg'] : messages['app.psd2.payment.rejectMsg']}
                                    </Text>
                                </div>
                                <div className="btnDone">
                                    <Button size='large' onPress={() => this.onDone()}>
                                        {messages['app.payment.psd2.doneBtn']}
                                    </Button>
                                </div>
                            </div>
                        }
                    />
                }

                {this.props.pis.isPaymentExecute === false &&
                    <Modal
                        isActive={true}
                        hideCloseButton={true}
                        header={<Text>{messages['app.psd2.payment.SuccessTitle']}</Text>}
                        content={
                            <div className="modalHeight">
                                <div className="modalNotification" tabIndex={0}>
                                    <StatusError width={30} color='#999' height={30} />
                                    <Text size={'header3'} className="sucessLabel">
                                        {messages['app.payment.psd2.consent.reject']}
                                    </Text>
                                </div>
                                <div className="modalMsg" tabIndex={0}>
                                    <Text size={'header4'} className="margin20">
                                        {messages['app.psd2.payment.rejectMsgbyUser']}
                                    </Text>
                                </div>
                                <div className="btnDone">
                                    <Button size='large' onPress={() => this.onDone()}>
                                        {messages['app.payment.psd2.doneBtn']}
                                    </Button>
                                </div>
                            </div>
                        }
                    />
                }
            </div >
        )
    }
}
export default createContainer({
    $queries: {
        i18n: {
            messages: true,
        },
        auth: {
            addBeneficiaryDisabled: true
        },
        savePaymentExecution: {
            $call: 'pis.executePayment'
        },
        changePage: { $call: 'ui.history.push' },
        pis: {
            isPaymentExecute: true,
            isPaymentOtpVerified: true,
            signConsent: { $call: 'signConsent' },
            resetPaymentStatus: { $call: 'resetPaymentStatus' }
        }
    },
})(PaymentInitiationService)
